import React, { forwardRef, useContext } from 'react';
import { EditorContext } from 'components/Editor';

const Video = forwardRef(({ src, children, ...attributes }, ref) => {
	// Use editor's context
	const { config } = useContext(EditorContext);

	return (
		<figure
			ref={ref}
			contentEditable={false}
			{...attributes}
		>
			<video controls className="w-full">
				<source src={`${process.env.REACT_APP_CDN}/${config.path}/${config.folder}/${src}`} />
			</video>

			{children}
		</figure>
	);
});

export default Video;
